// @flow
export const VOID = "VOID"; // when a string is necessary, but we want to indicate the value is to be disregarded
